import http from '@/utils/http'
import exam_enum from '../../utils/exam_enum';

//新高考

export const getGradeList = (params) => http.post('/marking-platform/school/grade/params', params) // 获取年级
// 获取单科考试
export const listSingle = (params) => http.post('/marking-exam-manager/exam-list/level-exam/single-exam', params).then(resp => {
  if (resp.body && resp.body.items) {
    resp.body.items.forEach(item => {
      item.typeDesc = exam_enum.getDescByKey(item.type, 'examType')
    });
  }
  return resp
})
export const addLevelExam = (params) => http.post('/marking-statistics/level/exam', params) // 创建考试
export const deleteLevelExam = (levelExamId) => http.delete(`/marking-statistics/level/exam/${levelExamId}`) // 删除考试
// 获取考试
export const getLevelExam = (levelExamId, isRegion = false) => http.get(`/marking-statistics/level/exam/${levelExamId}`, { isRegion }).then(resp => {
  if (resp.body) {
    resp.body.type = exam_enum.getCodeByKey(resp.body.examType)
  }
  return resp
})
// 获取考试列表
export const getLevelExamList = (params) => http.post('/marking-statistics/level/exam/search', params).then(resp => {
  if (resp.body && resp.body.items) {
    resp.body.items.forEach(item => {
      item.type = exam_enum.getCodeByKey(item.examType)
    })
  }
  return resp
})
export const updateExamLevel = (params) => http.put(`/marking-statistics/level/exam/${params.levelExamId}`, params) // 编辑考试
export const listStudents = (params) => http.post('/marking-statistics/level/exam/student/search', params) // 查询学生考试信息
export const setAbsentStudents = (params) => http.put(`/marking-statistics/level/exam/student/absent?isRegion=false&examId=${params.levelExamId}&status=${params.status}`, params.ids) // 设置不参与统计
export const regenerateReport = (params) => http.post('/marking-statistics/mq/send/statistics/message', params) // 重新生成报告
export const list_exam_by_school = (params) => http.post('/marking-statistics/level/exam/school-search-region', params).then(resp => {
  if (resp.body && resp.body.items) {
    resp.body.items.forEach(item => {
      item.type = exam_enum.getCodeByKey(item.examType)
    })
  }
  return resp
})     // 获取考试列表（学校）
export const downloadAbsentFile = (params) => http.get('/marking-statistics/level/exam/student/absent-file', params) // 下载不参与统计的学生
